<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <!--
    <div class="input-group-prepend">
      <button
        class="btn btn-default datepickerbutton"
        type="button"
        title="Toggle">
        <i class="fa fa-calendar"/>
      </button>
    </div>
    -->
    <date-picker
      :placeholder="label + ' (' + inputFormat + ')'"
      :value="fromValue(value)"
      :config="options"
      :disabled="disabled"
      :state="error ? false : null"
      @dp-change="$emit('input', processEvent($event))"
      @dp-error="$emit('input', null)"/><!--:wrap="true"-->
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import { text2moment, isMoment, unix2moment } from 'core/utils';

// Import this component
import DatePicker from 'vue-bootstrap-datetimepicker';

export default {
  components: {
    DatePicker
  },

  mixins: [ FormFieldMixin ],

  props: {
    inputFormat: {
      type: String,
      default: 'DD/MM/YYYY hh:mm:ss'
    },

    value: {
      type: [Object, Number, String],
      default: undefined
    },
  },

  data() {
    return {
      options: {
        showClear: true,
        // showClose: true,
        format: this.inputFormat,
        useCurrent: false
      }
    };
  },

  methods: {
    fromValue(value) {
      if (value === undefined || value === null) {
        return value;
      }

      if (isMoment(value)) {
        return value;
      } else if (typeof value === 'number') {
        return unix2moment(value, 'YYYY-MM-DD\'T\'hh:mm:ss');
      } else if (typeof value === 'string') {
        return text2moment(value, 'YYYY-MM-DD\'T\'hh:mm:ss');
      } else {
        throw Error('Could not convert value ' + value + ' to moment');
      }
    },

    processEvent(evt) {
      if (evt.date === false) {
        return null;
      }

      return evt.date;
    }
  }
};
</script>
<style>
@import '~pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
</style>
